<h2 mat-dialog-title>Justificativa</h2>
<mat-dialog-content>
  <div class="justificativa-content">
    {{ justificativaFormatada }}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="fechar()">Fechar</button>
</mat-dialog-actions>